// filepath: d:\Coding\Web Dev\ComplaintManagementSys\Frontend\inquiry-frontend\src\config\api.config.ts
// API configuration
export const API_URL = process.env.REACT_APP_BASE_URL;

export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  endpoints: {
    auth: {
      login: '/auth/login',
      register: '/auth/register',
    },
    users: '/users',
    complaints: '/complains',
    categories: '/categories',
    adminCategories: '/admin-categories',
  },
};
// Axios request interceptor configuration
export const setupAxiosInterceptors = (axios: any) => {
  // Services already prepend REACT_APP_BASE_URL, so do not set axios baseURL here.
  axios.interceptors.request.use(
    (config: any) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      // Check if request was cancelled/aborted
      if (error.code === 'ECONNABORTED') {
        console.warn('Request was aborted:', error);
        return Promise.reject(error);
      }

      if (error.response && error.response.status === 401) {
        console.warn('Received 401 Unauthorized response', {
          url: error.config.url,
          method: error.config.method
        });

        // Store the current URL to redirect back after login
        const currentPath = window.location.pathname;
        if (currentPath !== '/login') {
          sessionStorage.setItem('redirectAfterLogin', currentPath);
        }

        // Always redirect to login for 401 errors (token expired or invalid)
        console.log('Unauthorized access - redirecting to login page');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        // window.location.href = '/login';
      }

      return Promise.reject(error);
    }
  );
};
